import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, ButtonBase, TableCell, Typography } from '@mui/material';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import type { DriverType } from '@repo/supergraph-schemas/marketplace/types';
import { DisclosureTooltip } from '../../../../../DisclosureTooltip';

interface DetailsCellProps {
  drivers: DriverType[];
}

export const DetailsCell = memo(
  ({ drivers }: DetailsCellProps) => (
    <TableCell
      sx={{
        verticalAlign: 'top',
        borderColor: 'neutral.lighter2',
        paddingTop: 'var(--cell-padding-top)',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, height: '100%', paddingTop: 3 }}>
        {drivers.map(driver => (
          <Box key={driver.id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="bodySmallBold">{driver.label}</Typography>
            <Typography variant="textSmall">
              {driver.value ?? 'N/A'}
              {driver.valueTooltip && (
                <DisclosureTooltip
                  trigger={
                    <ButtonBase
                      aria-label={`${driver.label} info tooltip`}
                      disableRipple
                      sx={{
                        color: 'neutral.dark',
                        marginLeft: '6px',
                        verticalAlign: 'text-bottom',
                      }}
                    >
                      <HelpOutlineIcon sx={{ fontSize: '14px' }} />
                    </ButtonBase>
                  }
                >
                  <Typography variant="textSmall">{driver.valueTooltip}</Typography>
                </DisclosureTooltip>
              )}
            </Typography>

            {driver.description && (
              <Typography
                variant="textExtraSmall"
                sx={{ color: 'neutral.darker', fontSize: '10px' }}
              >
                {driver.description}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </TableCell>
  ),
  (prevProps, nextProps) => {
    return isEqual(prevProps.drivers, nextProps.drivers);
  },
);
